import { useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { ME_QUERY } from "graphql/APICalls";

const CREATE_GROUP_MUTATION = gql`
  mutation ($name: String!, $description: String) {
    createGroup(name: $name, description: $description) { id, shortId }
  }
`;

// TODO: on group creation, prompt user to turn on notifications

export default function CreateGroup(){

  const navigate = useNavigate();

  const [groupName, setGroupName] = useState('');
  const [groupDescription, setGroupDescription] = useState('');

  const [sendCreateGroupMutation] = useMutation(CREATE_GROUP_MUTATION);

  const handleGroupCreation = (e) => {
    e.preventDefault();
    sendCreateGroupMutation({
      variables: {name: groupName, description: groupDescription},
      onCompleted: data => navigate(`/g/${data.createGroup.shortId}`),
      refetchQueries: [ { query: ME_QUERY } ]
    })
  };

  return (
    <div className="centerer login-signup-overlay">
      <form className="centered form-1" onSubmit={handleGroupCreation}>
        <label>Group name</label>
        <input type="text" autoCapitalize="words" onChange={e => setGroupName(e.target.value)}/>
        <label>Description</label>
        <input type="text" autoCapitalize="sentences" style={{height: '5em'}} onChange={e => setGroupDescription(e.target.value)} />
        <button type="submit">Create group</button>
      </form>
    </div>
  )
}